import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {fetchServicesIfNeeded} from 'ondemand/actions/service';
import {fetchAgenciesIfNeeded} from 'ondemand/actions/agency';
import {fetchRidesIfNeeded} from 'ondemand/actions/ride';
import {changeSetting, changeSettings} from 'common/actions/settings';
import {fetchAgencySettingsIfNeeded} from 'common/actions/agencySettings';
import {getActiveAgency, getAgencySettings, getActiveServices} from 'ondemand/selectors';

import PageLayout from 'ondemand/components/PageLayout';
import AgencyPicker from 'ondemand/containers/AgencyPicker';
import AgencyServiceList from 'ondemand/components/AgencyServiceList';

class AgencyPage extends React.Component {
  static displayName = 'AgencyPage';

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    agency: PropTypes.object,
    agencySettings: PropTypes.object,
    services: PropTypes.array,
    agencyId: PropTypes.string,
    serviceId: PropTypes.string,
    route: PropTypes.object,
  };

  componentDidMount() {
    this.props.dispatch(fetchAgenciesIfNeeded());
    this.props.dispatch(fetchRidesIfNeeded());
    if (this.props.agencyId) {
      this.props.dispatch(fetchAgencySettingsIfNeeded(this.props.agencyId));
      this.props.dispatch(fetchServicesIfNeeded(this.props.agencyId));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.agencyId && prevProps.agencyId !== this.props.agencyId) {
      this.props.dispatch(fetchAgencySettingsIfNeeded(this.props.agencyId));
      this.props.dispatch(fetchServicesIfNeeded(this.props.agencyId));
    }
  }

  _handleAgencyClick = () => {
    this.props.dispatch(
      changeSettings({
        agencyId: null,
        serviceId: null,
      })
    );
  };

  _handleServiceClick = (service) => {
    this.props.dispatch(changeSetting('serviceId', service.service_id));
  };

  render() {
    return (
      <PageLayout dataId={'agency-page-container'} title="My Agency">
        {this.props.agency && this.props.services &&
          <AgencyServiceList
            agency={this.props.agency}
            agencySettings={this.props.agencySettings}
            services={this.props.services}
            onAgencyClick={this._handleAgencyClick}
          />
        }
        <AgencyPicker />
      </PageLayout>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user || {},
  agency: getActiveAgency(state),
  agencySettings: getAgencySettings(state),
  services: getActiveServices(state),
  agencyId: state.settings.agencyId || null,
  serviceId: state.settings.serviceId || null,
});

export default connect(mapStateToProps)(AgencyPage);



// WEBPACK FOOTER //
// ./src/ondemand/containers/AgencyPage.js